import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import ShoreBoundRow from "features/planner/report/helicopter/components/ShoreBound/ShoreBoundRow";
import OffshoreBoundRow from "features/planner/report/helicopter/components/OffshoreBound/OffshoreBoundRow";

const ShoreOffshoreBoundRow = ({ classes, index }) => (
  <Grid container className={classes.root}>
    <Grid item xs={8}>
      <OffshoreBoundRow index={index} />
    </Grid>
    <Grid item xs={4} className={classes.shoreBound}>
      <ShoreBoundRow index={index} />
    </Grid>
  </Grid>
);

const styles = () => ({
  root: {
    marginTop: -1,
    pageBreakInside: "avoid",
    border: `1px solid ${grey[300]}`,
  },
  shoreBound: {
    borderLeft: `1px solid ${grey[300]}`,
  },
});

export default compose(withStyles(styles))(ShoreOffshoreBoundRow);
